import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { triggerPulse } from '@wix/ambassador-individual-scheduling-assistant-v1-pulse/http';
import { HttpBaseClient } from '../BaseClient/HttpBaseClient';
import { PulseClientBase } from './PulseClientBase';
export class PulseClient extends HttpBaseClient(PulseClientBase) {
  constructor() {
    super(...arguments);
    _defineProperty(this, "triggerPulseImpl", triggerPulse);
  }
}
//# sourceMappingURL=PulseClientHttp.js.map